/**
 * Phase 14 — SVG-Mockup für das Hero-Bild. Stilisierte Karte mit drei
 * pulsierenden Mission-Markern in den drei Org-Farben.
 *
 * Dimensions match the existing GameUiMockup conventions: viewBox 800×500,
 * dunkler Map-Hintergrund + Routen-Strukturen + Marker.
 */
export function HeroMapMockup() {
  return (
    <svg
      viewBox="0 0 800 500"
      className="h-auto w-full rounded-xl shadow-2xl"
      role="img"
      aria-label="Vorschau: Karte mit drei aktiven Einsätzen"
    >
      <defs>
        <linearGradient id="hero-bg" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#0b1426" />
          <stop offset="100%" stopColor="#050810" />
        </linearGradient>
        <radialGradient id="firePulse" cx="50%" cy="50%" r="50%">
          <stop offset="0%" stopColor="#dc2626" stopOpacity="0.85" />
          <stop offset="100%" stopColor="#dc2626" stopOpacity="0" />
        </radialGradient>
        <radialGradient id="emsPulse" cx="50%" cy="50%" r="50%">
          <stop offset="0%" stopColor="#f97316" stopOpacity="0.85" />
          <stop offset="100%" stopColor="#f97316" stopOpacity="0" />
        </radialGradient>
        <radialGradient id="policePulse" cx="50%" cy="50%" r="50%">
          <stop offset="0%" stopColor="#2563eb" stopOpacity="0.85" />
          <stop offset="100%" stopColor="#2563eb" stopOpacity="0" />
        </radialGradient>
      </defs>

      <rect width="800" height="500" fill="url(#hero-bg)" />

      {/* Streets — gentle grid with curves */}
      <g stroke="#1f2937" strokeWidth="1.4" opacity="0.9">
        {Array.from({ length: 14 }).map((_, i) => (
          <line key={`v${i}`} x1={i * 60} y1={0} x2={i * 60 + 30} y2={500} />
        ))}
        {Array.from({ length: 9 }).map((_, i) => (
          <line key={`h${i}`} x1={0} y1={i * 60} x2={800} y2={i * 60 - 18} />
        ))}
      </g>

      <g stroke="#334155" strokeWidth="2.5" fill="none" opacity="0.8">
        <path d="M 0 250 Q 250 220 420 280 T 800 250" />
        <path d="M 380 0 Q 400 150 420 280 Q 440 410 400 500" />
      </g>

      {/* District blobs */}
      <circle cx="180" cy="160" r="120" fill="#1e3a8a" opacity="0.12" />
      <circle cx="600" cy="360" r="140" fill="#7f1d1d" opacity="0.12" />
      <circle cx="640" cy="120" r="80" fill="#7c2d12" opacity="0.10" />

      {/* Fire mission marker */}
      <g>
        <circle cx="200" cy="180" r="38" fill="url(#firePulse)">
          <animate attributeName="r" values="20;42;20" dur="2.4s" repeatCount="indefinite" />
        </circle>
        <circle cx="200" cy="180" r="9" fill="#dc2626" stroke="#ffffff" strokeWidth="1.5" />
      </g>

      {/* EMS mission marker */}
      <g>
        <circle cx="540" cy="320" r="38" fill="url(#emsPulse)">
          <animate attributeName="r" values="20;42;20" dur="2.7s" repeatCount="indefinite" />
        </circle>
        <circle cx="540" cy="320" r="9" fill="#f97316" stroke="#ffffff" strokeWidth="1.5" />
      </g>

      {/* Police mission marker */}
      <g>
        <circle cx="640" cy="140" r="34" fill="url(#policePulse)">
          <animate attributeName="r" values="18;38;18" dur="2.1s" repeatCount="indefinite" />
        </circle>
        <circle cx="640" cy="140" r="9" fill="#2563eb" stroke="#ffffff" strokeWidth="1.5" />
      </g>

      {/* Vehicle dot moving along route */}
      <g>
        <circle cx="320" cy="240" r="5" fill="#ffffff" stroke="#3b82f6" strokeWidth="1.8">
          <animate attributeName="cx" values="320;420;540" dur="6s" repeatCount="indefinite" />
          <animate attributeName="cy" values="240;280;320" dur="6s" repeatCount="indefinite" />
        </circle>
      </g>

      {/* Station markers */}
      <rect x="118" y="244" width="14" height="14" fill="#dc2626" stroke="#ffffff" strokeWidth="1" />
      <rect x="450" y="186" width="14" height="14" fill="#f97316" stroke="#ffffff" strokeWidth="1" />
      <rect x="694" y="320" width="14" height="14" fill="#2563eb" stroke="#ffffff" strokeWidth="1" />
    </svg>
  );
}
